const CompanyRoles = {
  methods: {
    getShortRoleDescription(emp) {
      let roles = []
      if (emp.apprentice) roles.push('LÄR')
      if (emp.isInstructor) roles.push('HL')
      if (emp.isCompanyEducationResponsible) roles.push('YUA')
      if (emp.isDistanceEducationAdministrator) roles.push('ATT')
      if (emp.isAdministrator) roles.push('ADM')
      return roles.join(', ')
    },

    getRoleDescription(emp) {
      let roles = []
      if (emp.apprentice) roles.push('Lärling')
      if (emp.isInstructor) roles.push('Handledare')
      if (emp.isCompanyEducationResponsible) roles.push('Yrkesutbildningsansvarig')
      if (emp.isDistanceEducationAdministrator) roles.push('Beställningsgodkännare')
      if (emp.isAdministrator) roles.push('Administratör')
      return roles.join(', ')
    },

    getDepartmentRole(dep) {
      let roles = []
      if (dep.isDepartmentInstructor) roles.push('Handledare')
      if (dep.isDepartmentEducationResponsible) roles.push('Yrkesutbildningsansvarig')
      if (dep.isDepartmentDistanceEducationAdministrator) roles.push('Beställningsgodkännare')
      if (dep.isDepartmentAdministrator) roles.push('Avdelningsadministratör')
      dep.role = roles
      return dep
    },

    getRoleAvatar(emp) {
      let avatar = ''
      if (emp.apprentice) avatar = '$sl-apprentice'
      else if (emp.isInstructor) avatar = '$sl-instructor'
      else if (emp.isCompanyEducationResponsible) avatar = '$sl-yua'
      else if (emp.isDistanceEducationAdministrator) avatar = '$sl-distance-admin'
      else if (emp.isAdministrator) avatar = '$sl-admin'

      return avatar
    }
  }
}

export default CompanyRoles
